//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'VisitList',
  data() {
    return {
      activeIndex: null,
      list: []
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    this.getUserPointsRecord()
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY/MM/DD')
    },
    getTime (createdAt) {
      return moment(createdAt).format('YYYY/MM/DD HH:mm')
    },
    getUserPointsRecord () {
      this.$store.httpDispatch({})('getUserPointsRecord')
      .then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.list = res.data.data.records
        }
      })
    }
  }
}
